/**
 * Country-aware phone input wrapping `react-international-phone`.
 *
 * - Defaults to Germany (+49).
 * - Numeric inputMode → iOS shows the digit keypad.
 * - Dropdown to switch country prefix without losing the typed number.
 * - Output is the E.164 number ("+491701234567"), accessible via onChange.
 */
import { PhoneInput as IntlPhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "./phone-input.css";

export function PhoneInput({ value, onChange, testId = "phone-input", placeholder = "170 0000000" }) {
  return (
    <div data-testid={`${testId}-wrapper`} className="phone-input-wrapper">
      <IntlPhoneInput
        defaultCountry="de"
        preferredCountries={["de", "at", "ch", "fr", "it", "es", "nl", "pl", "be", "lu"]}
        value={value}
        onChange={(phone) => onChange(phone)}
        placeholder={placeholder}
        inputProps={{
          "data-testid": testId,
          inputMode: "tel",
          autoComplete: "tel",
        }}
      />
    </div>
  );
}
